var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForbid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca4539;}.b{opacity:0;}.c{fill:#fff;}.d{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-465 -5466)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-388.5 5206)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.5,3.543A11.957,11.957,0,0,0,7.045,23.955a11.957,11.957,0,1,0,16.91-16.91,11.879,11.879,0,0,0-8.455-3.5M15.5,0A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z",
    transform: "translate(855.5 262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.631,3.327H0V0H24.631Z",
    transform: "translate(863.468 267.615) rotate(45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 35,
    height: 35,
    transform: "translate(500 5501) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,1V34H34V1H1M0,0H35V35H0Z",
    transform: "translate(500 5501) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForbid);
export default __webpack_public_path__ + "static/media/icon_forbid.f7db1a54df28b702e1b6351e2ef6b75f.svg";
export { ForwardRef as ReactComponent };